import styled from "styled-components";

const Menu = styled.section`
    background: #1571B3;
    padding: 25px;

    h1 {
        font-size: xx-large;
        color:  #010101;
        text-decoration: inherit;
    }
`;

export {
    Menu
}